import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import themeClasses from 'webapp/helpers/theme-classes';

export default class AppNotificationsDemoUserComponent extends Component {
	@service('account') declare accountService: Service.Account;

	trackingType = 'top_banner';

	get isExistingUser(): boolean {
		return this.accountService.isExistingUserAccount;
	}

	get isExistingUserEmailSet(): boolean {
		return this.accountService.isExistingUserEmailSet;
	}

	get isExistingUserOrEmailSet(): boolean {
		return this.isExistingUser || this.isExistingUserEmailSet;
	}

	get mainButtonText(): string {
		if (this.isExistingUserEmailSet) {
			return 'Back to my account';
		} else if (this.isExistingUser) {
			return 'Login with your account';
		} else {
			return 'Create account';
		}
	}

	get mainButtonTheme(): string {
		return this.isExistingUserOrEmailSet ? 'blue' : 'green';
	}

	@action
	redirect(): void {
		if (this.isExistingUserEmailSet) {
			void this.accountService.redirectToMainAccount(this.trackingType);
		} else if (this.isExistingUser) {
			this.accountService.redirectToLogin(this.trackingType);
		} else {
			this.accountService.redirectToSignup(this.trackingType);
		}
	}
	<template>
		<div
			class="notification-container demo-user-notification
				{{if this.isExistingUserOrEmailSet 'demo-user-notification--existing'}}"
		>
			<div class="container">
				<p>
					You are exploring a demo account
				</p>
				<a
					class="button {{themeClasses this.mainButtonTheme}} size-small"
					{{on "click" this.redirect}}
				>
					{{this.mainButtonText}}
				</a>
				{{#unless this.isExistingUserOrEmailSet}}
					<a
						href="https://databox.com/demo"
						class="button theme-blue-outlined size-small"
						target="_blank"
					>
						Book a demo
					</a>
				{{/unless}}
			</div>
		</div>
	</template>
}
